import { render, staticRenderFns } from "./redesSociales.vue?vue&type=template&id=a1ae718a&scoped=true&"
import script from "./redesSociales.vue?vue&type=script&lang=js&"
export * from "./redesSociales.vue?vue&type=script&lang=js&"
import style0 from "./redesSociales.vue?vue&type=style&index=0&id=a1ae718a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae718a",
  null
  
)

export default component.exports